import {
    Scope,
} from "@mrflark/auth";
import type {
    AuthIdentity,
} from "@mrflark/auth";
import type {
    ComponentChildren,
    VNode,
} from "preact";
import {
    useEffect,
} from "preact/hooks";
import {
    authGatewayClient,
} from "../../api/client.ts";
import {
    useAuthStore,
} from "../../stores/authStore.ts";

type AuthProviderProps = {
    children: ComponentChildren;
};

export const AuthProvider = ({
    children,
}: AuthProviderProps): VNode => {
    const {
        setAuth,
        clearAuth,
    } = useAuthStore();

    useEffect(() => {
        const checkAuth = async (): Promise<void> => {
            try {
                const identity = await authGatewayClient.get<AuthIdentity>(
                    "/auth/me",
                );
                // @mrflark/auth's AuthIdentity ships userId as string
                // (carrying the X-Auth-* header verbatim) while
                // @mrflark/core's auth store expects number. coerce
                // here rather than papering the inconsistency over
                // upstream — the auth gateway's userId column is
                // always numeric in the DB
                setAuth(
                    Number(identity.userId),
                    identity.username,
                    identity.scopes.includes(Scope.Admin),
                );
            } catch {
                clearAuth();
            }
        };

        checkAuth();
    }, [setAuth, clearAuth]);

    return <>{children}</>;
};
